'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiCreditCard = function TiCreditCard(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.3 11.7h-18.3c-2.8 0-5 2.2-5 5v11.6c0 2.8 2.2 5 5 5h18.3c2.8 0 5-2.2 5-5v-11.6c0-2.8-2.2-5-5-5z m1.7 16.6c0 1-0.7 1.7-1.7 1.7h-18.3c-0.9 0-1.7-0.7-1.7-1.7v-6.6h21.7v6.6z m0-10h-21.7v-1.6c0-1 0.8-1.7 1.7-1.7h18.3c1 0 1.7 0.7 1.7 1.7v1.6z m-6.7 8.4h3.4c0.4 0 0.8-0.4 0.8-0.9s-0.4-0.8-0.8-0.8h-3.4c-0.4 0-0.8 0.4-0.8 0.8s0.4 0.9 0.8 0.9z' })
        )
    );
};

exports.default = TiCreditCard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/credit-card.js
// module id = 2025
// module chunks = 0